/*
 * @author Mateusz Mieszczak <mateusz.mieszczak at bossbyte.com>
 * @copyright BossByte Web Application
 */


app.controller('Backup', function($scope, $http, _$toast, $rootScope) {

    $scope.creating = false;
    $scope.create = function() {
        $scope.creating = true;
        $http.get('/administration/backup/create')
            .success(function(result) {
                $scope.creating = false;
                _$toast.message('Kopia zapasowa została utworzona');
                $scope.getFiles();
            });
    };

    $scope.getFiles = function() {
        $http.get('/administration/backup/files')
            .success(function(files) {
                $scope.files = files;
            });
    };

    $scope._init = function() {
        $scope.getFiles();
    };
    $scope._init();


    $scope.removeBackup = function(fileName) {
        $http.post('/administration/backup/remove', {
            'name': fileName
        }).success(function(response) {
            if (parseInt(response) == 1) {
                $rootScope.notification.show('success', 'Plik został usunięty');
                $scope._init();
            } else if (parseInt(response) == -1) {
                $rootScope.notification.show('error', 'Plik nie istnieje');
            } else {
                $rootScope.notification.show('error', 'Plik nie został usunięty');
            }
        });
    };
});
